import { fmtAt, fmtViewer } from "./jobMeta";

/** A server time shown in Mountain time, with the viewer's own time underneath (or in brackets when inline). */
export function When({ iso, testid, className = "block" }) {
  const mine = fmtViewer(iso);
  const inline = className.split(" ").includes("inline");
  const vt = testid ? `${testid}-viewer` : undefined;
  return (
    <span className={className} data-testid={testid}>
      {fmtAt(iso)}{mine && <span className="text-[10px] text-slate-400"> MT</span>}
      {mine && (inline
        ? <span className="text-slate-500" data-testid={vt}> ({mine} your time)</span>
        : <span className="block text-[10px] text-slate-500" data-testid={vt}>{mine} · your time</span>)}
    </span>
  );
}
